import { lazy } from "react";

/**
 * Enhanced React.lazy with automatic reload retry on ChunkLoadError.
 * When a new deployment happens, older chunk hashes on client browsers fail to load (404/MIME error).
 * This wrapper catches that error and triggers a clean window.location.reload() once to fetch the latest assets.
 */
export const lazyWithRetry = (componentImport) =>
  lazy(async () => {
    const pageHasBeenForceRefreshed = JSON.parse(
      window.sessionStorage.getItem("vivashri_chunk_force_refreshed") || "false"
    );

    try {
      const component = await componentImport();
      window.sessionStorage.setItem("vivashri_chunk_force_refreshed", "false");
      return component;
    } catch (error) {
      console.warn("Dynamic chunk load error detected:", error);

      if (!pageHasBeenForceRefreshed) {
        // Chunk failed to load (usually due to a new deployment). Auto-reload once to get new version.
        window.sessionStorage.setItem("vivashri_chunk_force_refreshed", "true");
        window.location.reload();
        return { default: () => null };
      }

      // If it still fails after a reload, rethrow for ErrorBoundary to catch
      throw error;
    }
  });

export default lazyWithRetry;
